import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

import { YakSplashScreen } from '~/components/ui/YakSplashScreen';

export const Route = createFileRoute('/')({
  component: IndexComponent,
});

function IndexComponent() {
  // Track mount to ensure SSR and client render the same initial HTML
  // This prevents hydration mismatch when other routes are accessed directly
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // During SSR and initial client render, show YakSplashScreen
  // This ensures all routes have the same initial HTML shell
  if (!isMounted) {
    return <YakSplashScreen />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900">Yak Network Play</h1>
        <p className="mt-2 text-gray-600">
          Navigate to a landing page URL to start playing.
        </p>
      </div>
    </div>
  );
}
